import ExportCSVUseCase from './ExportCSVUseCase';

export function exportCSVUseCase() {
    return new ExportCSVUseCase()
}
